var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loginbox'),_vm._v(" "),_c('search'),_vm._v(" "),_c('tablist',{attrs:{"title":'出售大厅',"showbtn":true,"detailshow":true},on:{"funBuy":_vm.funBuy}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10382b65","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hall/hall.vue
// module id = 473
// module chunks = 13